import { ConversationMessageType } from 'lib/enum/conversation-message-type.enum';
import { AgentSessionEvent } from '../Conversation/types';

export enum ConversationalAgentStatus {
    Enabled = 'enabled',
    Disabled = 'disabled',
}

export interface ConversationalAgent {
    id: string;
    name: string;
    description: string;
    status: ConversationalAgentStatus;
    metadata: { acri: string };
    reminderMessageEnabled: boolean;
}

export interface CreateConversationalAgentBody {
    uuid: string;
    name: string;
    description: string;
    reminderMessageEnabled: boolean;
}

export interface UpdateConversationalAgentBody {
    name: string;
    description: string;
    reminderMessageEnabled: boolean;
}

export type FormField = {
    name: string;
    value: string;
};

export type ConversationalAgentCollection = ConversationalAgent[];

export enum AiMessageDirection {
    Incoming = 'incoming',
    Outgoing = 'outgoing',
}

export enum SimulateConversationTriggerType {
    IncomingMessage = 'incoming_message',
    Timeout = 'timeout',
    Reminder = 'reminder',
}

export type LocalSimulatedMessage = SimulatedMessage & {
    messageType?: ConversationMessageType;
    templateId?: string;
    message?: {
        body?: string;
        buttons?: any[];
        text?: string;
    };
};

export enum SimulatedEntrySource {
    WebsiteWidget = 'website_widget',
    LinkedIn = 'linkedin',
    Meta = 'meta',
}

export type SimulatedMessage = {
    id: string;
    direction: AiMessageDirection;
    createdAt: string;
    text: string;
};

export type SimulatedTalentEntry = {
    title: string | null;
    url: string | null;
    formFields: FormField[];
    source: SimulatedEntrySource;
};

export interface SimulateConversationRequest {
    aiSchema: string;
    messages: Omit<SimulatedMessage, 'id'>[];
    triggerType: SimulateConversationTriggerType;
    activationContext?: string | null;
    simulatedTalentEntry?: SimulatedTalentEntry | null;
}

export interface SimulateConversationResponse {
    sessionEvents: AgentSessionEvent[];
    message: {
        text: string;
        agentExplanation: string;
        createdAt: string;
    } | null;
}
